import gql from 'graphql-tag';

export const defaultConnextDataQuery = gql`
fragment connextdata on ConnextData {
  id
  userLevel
  hasOwner
  operator
  users {
    email
    operator
    userLevel
  }
  config {
    TZ
    sensor_mode
    latitude
    longitude
    maxLoadPwr
    invCurrSensO
    invCurrSensTR
    pType
    connection
    ta_sign
    mt_sign
    net
    configVerified
  }
  devices {
    ...on EvChType {
      active
      carConsumption
      chargerMode
      dModel
      fwVer
      inputGreenPower
      limitPower
      ready
      rsn
      sn
      st_cmd
      startTime
      status
      timestamp
      tpDuration
      tpPower
      tStart
      type
    }
    ...on inverterType {
      type
      sn
      id
      modbus_address
      k
    }
  }
  info {
    sn {
      sn
      uid
    }
    fw {
      fota_status
      fw_ver
      fwCategory
    }
    connection {
      status
      timestamp
      disconnectReason
      ipAddress
    }
  }
}
`;

export const connextDataQueryForPorting = gql`
fragment connextdata on ConnextData {
  id
  userLevel
  hasOwner
  operator
  devices {
    ...on inverterType {
      type
      sn
      id
      modbus_address
      k
    }
  }
  info {
    sn {
      sn
      uid
    }
  }
}
`;
